import { placeholderImage } from "@grandvisionhq/utils";
const DEFAULT_SUFFIX = "?q=70&w=1200&h=630&fit=fill&fm=jpeg";
const THUMBNAIL_SUFFIX = "?w=64&fm=jpeg&auto=format";
const getProductImageUrl = (media, suffix) => {
  if (!media?.images || !media?.images.length) {
    return `${placeholderImage.url}${suffix ?? DEFAULT_SUFFIX}`;
  }
  return `${media?.images.filter((image) => image.label === "Front")[0]?.url}${suffix ?? DEFAULT_SUFFIX}`;
};
const getVariantItemImageUrl = (media) => getProductImageUrl(media, THUMBNAIL_SUFFIX);
export {
  getProductImageUrl,
  getVariantItemImageUrl
};
//# sourceMappingURL=get-product-image-url.js.map
